<div class="flex justify-center items-center static w-full">
	<div class="flex flex-col w-full">
		<div>
			<form
				(ngSubmit)="onSubmit(loginForm)"
				#loginForm="ngForm"
				class="flex flex-1 flex-col justify-center items-center gap-4"
			>
				<ng-template #itemTemplate let-item>
					<div class="flex flex-col">
						<span>{{ item?.value?.accountName }}</span>
						<span class="text-grey text-xs">{{
							item?.value?.description
						}}</span>
					</div>
				</ng-template>
				<div class="w-full" *ngIf="!lockAccountName">
					<app-dropdown
						*ngIf="accountNameOptions?.length > 0"
						label="Account name"
						[required]="true"
						[itemGroups]="[
							{ items: accountNameOptions, template: itemTemplate },
						]"
						[value]="form_accountName"
						(onSelect)="onAccountNameSelected($event)"
						class="w-full"
						[testHook]="testHooks.AccountNameDropdown"
					></app-dropdown>
					<app-input
						*ngIf="!accountNameOptions?.length"
						label="Account name"
						[required]="true"
						[(ngModel)]="form_accountName"
						[name]="FORM_VALUES.ACCOUNTNAME"
						class="w-full"
						[testHook]="testHooks.AccountName"
					></app-input>
				</div>

				<div
					*ngIf="lockAccountName"
					class="border-t border-b border-grey-lighter bg-grey-lightest py-2 px-2 mb-5 w-full"
				>
					<div class="flex justify-between items-center">
						<div class="flex gap-5">
							<div>Account name:</div>
							<div class="font-bold">{{ form_accountName }}</div>
						</div>
						<app-anchor
							(onClick)="closeModal()"
							[tooltip]="manageAccountTooltip"
							[disabled]="!isLoggedInUserAdmin"
							[testHook]="testHooks.Link"
						>
							<app-icon
								[icon]="ICON.EDIT"
								[testHook]="testHooks.EditIcon"
							></app-icon>
						</app-anchor>
					</div>
				</div>

				<app-input
					class="w-full"
					label="Username"
					[required]="true"
					placeholder="Username"
					[(ngModel)]="form_username"
					[name]="FORM_VALUES.USERNAME"
					[testHook]="testHooks.Username"
				></app-input>
				<div class="w-full">
					<app-input
						class="w-full"
						label="Password"
						type="password"
						[required]="true"
						placeholder="Password"
						autocomplete="on"
						[(ngModel)]="form_password"
						[name]="FORM_VALUES.PASSWORD"
						[testHook]="testHooks.Password"
					></app-input>
					<p
						class="mt-3 text-xs font-semibold w-full text-right cursor-pointer hover:text-green"
						(click)="changePassword()"
					>
						Forgot password?
					</p>
				</div>

				<div *ngIf="error && error?.length > 0" class="mt-4">
					<div
						class="mx-auto flex flex-col px-4 py-5 bg-red-100 rounded-2xl w-10/12 my-2"
					>
						<p>{{ error }}</p>
						<p *ngIf="errorCode === 'DAW20010'">
							Please ensure you’re using valid Teranet Connect credentials
							rather than Teraview credentials. To register for Teranet Connect,
							<a
								class="color-400 underline md:no-underline;"
								externalNavInterceptor
								href="https://my.teranetconnect.ca/registration/tvDesktopLogin.form"
								target="_blank"
								[testHook]="testHooks.Link1"
							>
								click here.</a
							>
						</p>
						<p *ngIf="errorCode === 'DAW21502'">
							To reset your password in Teranet Connect please
							<a
								class="color-400 underline font-bold"
								externalNavInterceptor
								href="https://my.teranetconnect.ca/registration/tvDesktopLogin.form"
								target="_blank"
								[testHook]="testHooks.Link2"
								>click here.</a
							>
						</p>
					</div>
				</div>

				<span class="flex mt-11 justify-between w-full">
					<app-button
						btn="border"
						(click)="closeModal()"
						[testHook]="testHooks.CloseButton"
						>Close</app-button
					>
					<app-button
						type="submit"
						[disabled]="loginForm.invalid"
						[testHook]="testHooks.LoginButton"
						>{{ submitButtonText }}</app-button
					>
				</span>
			</form>
		</div>
	</div>

	<app-loading [show]="loading" text="...Logging you in"></app-loading>
</div>
